const getPickupList = state => state.pickupList;

export default {
  getPickupList,
};



// WEBPACK FOOTER //
// ./src/store/modules/pickup/getters.js